module.exports = __webpack_public_path__ + "img/hero-sierras-le_hannahwhiteley.d0f5ff4.jpg";